// bingo-ready.js — run a builder glue init once the controls it binds are in
// the DOM, on either of the two ways the builder is served:
//
//   - server-inlined (the no-JS `/builder` page and the manage editor render
//     the whole form, scripts last) — the controls are already present, so
//     `init` runs and binds immediately;
//   - the static shell at `/kill-team/bingo`, which paints instantly and
//     htmx-loads the Advanced Settings body (`#bingo-advanced-body`) after
//     first paint — `init` finds its controls missing, returns falsy, and is
//     retried when that body swaps in.
//
// `init` returns truthy once it has bound; until then it's re-run on each
// Advanced Settings swap. It runs to completion at most once: the early calls
// bail at their own element guards before binding anything.

/**
 * @param {() => boolean} init binds the controls and reports whether it
 *   found them; re-run on each Advanced Settings swap until it has
 */
export function whenBuilderReady(init) {
  if (init()) return;
  /** @param {Event} e an `htmx:afterSwap` event */
  function onSwap(e) {
    const target = /** @type {Element | null} */ (e.target);
    if (target && target.id === "bingo-advanced-body" && init()) {
      document.body.removeEventListener("htmx:afterSwap", onSwap);
    }
  }
  document.body.addEventListener("htmx:afterSwap", onSwap);
}
